import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import MainLayout from "../../../layout";
import FormTextField from "../../../components/form/text";
import { FormImageField } from "../../../components/form/image";
import { FormTextAreaField } from "../../../components/form/text-area";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { url } from "../../../config";
import successToast from "../../../components/toast/successToast";
import errorToast from "../../../components/toast/errorToast";
import backArrow from "../../../assets/icons/back-arrow.svg";

const CreateUsers = () => {
  const navigate = useNavigate();
  const initialValues = {
    profile_picture: "",
    email: "",
    name: "",
    password: "",
    // confirm_password: "",
    description: "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Required").email("Invalid email"),
    password: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    console.log(values, "values");
    axios
      .post(`${url}/ffadmin/create`, values)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        navigate(`/admin/users/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };
  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          <Form>
            <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
              <div className="flex items-center gap-2">
                <button
                  onClick={() => navigate("/admin/users/list")}
                  type="button"
                >
                  <img src={backArrow} alt="<" width={10} height={10} />
                </button>
                <h2 className="text-xl font-semibold capitalize">
                  Admin Users - Create
                </h2>
              </div>

              <div className="flex gap-3 items-center">
                <button
                  onClick={() => navigate("/admin/users/list")}
                  type="button"
                  className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                >
                  Create
                </button>
              </div>
            </div>
            <section className="w-full max-w-[40rem]">
              <div className="my-4">
                <FormImageField
                  name={"profile_picture"}
                  label={"profile picture"}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"name"}
                  label={"name"}
                  placeholder={`Enter your name`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"email"}
                  label={"Email"}
                  placeholder={`Enter your email`}
                />
              </div>
              <div className="my-4">
                <FormTextField
                  name={"password"}
                  label={"password"}
                  placeholder={`Enter your password`}
                />
              </div>
              <div className="my-4">
                <FormTextAreaField
                  name={"description"}
                  label={"Description"}
                  placeholder={`Enter description`}
                />
              </div>
            </section>
          </Form>
        </Formik>
      </section>
    </MainLayout>
  );
};

export default CreateUsers;
